import { render, staticRenderFns } from "./LaravelDevelopment.vue?vue&type=template&id=1f315e61&"
import script from "./LaravelDevelopment.vue?vue&type=script&lang=js&"
export * from "./LaravelDevelopment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports